(function () {
  'use strict';

  /* =========================================================
     All interactions use event delegation on document, so they
     keep working after Shopify's theme editor re-renders a
     section (which destroys directly-bound listeners).
     ========================================================= */

  /* ---------- Mobile nav (burger) ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('.jtj-burger');
    if (!burger) return;
    var nav = burger.closest('.jtj-header').querySelector('.jtj-nav');
    if (!nav) return;
    var header = burger.closest('.jtj-header');
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--jtj-header-h', Math.max(0, rect.bottom) + 'px');
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('jtj-drawer-open', open);
  });

  /* ---------- Mobile mega column sub-accordion (+/-) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.jtj-subtoggle2');
    if (!t) return;
    e.preventDefault();
    var col = t.closest('.jtj-mega2__col');
    if (!col) return;
    var open = col.classList.toggle('is-expanded');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    slidePanel(col.querySelector('.jtj-mega2__list'), open);
    /* growing a column must not be clipped by its open parent panel */
    var parentPanel = col.closest('.jtj-mega');
    if (parentPanel && parentPanel.style.maxHeight && parentPanel.style.maxHeight !== 'none' && parentPanel.style.maxHeight !== '0px') {
      parentPanel.style.maxHeight = 'none';
    }
  });

  /* ---------- Mobile accordion: animate to measured height ---------- */
  function slidePanel(el, open) {
    if (!el) return;
    if (open) {
      el.style.maxHeight = el.scrollHeight + 'px';
      var done = function (ev) {
        if (ev.target !== el) return;
        if (el.style.maxHeight !== '0px') el.style.maxHeight = 'none';
        el.removeEventListener('transitionend', done);
      };
      el.addEventListener('transitionend', done);
    } else {
      if (getComputedStyle(el).maxHeight === 'none') {
        el.style.maxHeight = el.scrollHeight + 'px';
        void el.offsetHeight; /* commit before collapsing */
      }
      el.style.maxHeight = '0px';
    }
  }
  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.jtj-faq__toggle');
    if (!t) return;
    var item = t.closest('.jtj-faq__item');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    slidePanel(item.querySelector('.jtj-faq__panel'), open);
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.jtj-subtoggle');
    if (!toggle) return;
    e.preventDefault();
    var li = toggle.closest('li');
    var open = li.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    slidePanel(li.querySelector(':scope > ul, :scope > .jtj-mega'), open);
  });

  /* ---------- PDP gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jtj-pdp__thumb');
    if (!btn) return;
    var mainImg = document.getElementById('jtj-main-img');
    if (mainImg) mainImg.src = btn.getAttribute('data-full');
    document.querySelectorAll('.jtj-pdp__thumb').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
  });

  /* ---------- PDP variant price sync ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('#jtj-variant-select');
    if (!sel) return;
    var price = sel.options[sel.selectedIndex].getAttribute('data-price');
    var p1 = document.getElementById('jtj-price');
    var p2 = document.getElementById('jtj-btn-price');
    if (price && p1) p1.textContent = price;
    if (price && p2) p2.textContent = price;
  });

  /* ---------- Money formatting ---------- */
  function moneyFormatter() {
    var cartEl = document.querySelector('.jtj-cart');
    var iso = (cartEl && cartEl.getAttribute('data-currency')) || 'USD';
    try {
      var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: iso });
      return function (cents) { return fmt.format(cents / 100); };
    } catch (err) {
      return function (cents) { return '$' + (cents / 100).toFixed(2); };
    }
  }

  /* ---------- AJAX cart ---------- */
  function showQtyNote(row, msg) {
    var note = row.querySelector('[data-qty-note]');
    if (!note) return;
    note.textContent = msg;
    note.classList.add('is-visible');
    clearTimeout(note._t);
    note._t = setTimeout(function () { note.classList.remove('is-visible'); }, 4000);
  }

  function flashTotal() {
    var tot = document.getElementById('jtj-total');
    if (!tot) return;
    tot.classList.add('is-flash');
    setTimeout(function () { tot.classList.remove('is-flash'); }, 400);
  }

  function updateCartDom(cart, ctx) {
    var money = moneyFormatter();
    document.querySelectorAll('.jtj-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    if (cart.item_count === 0) { window.location.reload(); return; }
    var keys = {};
    var lineByKey = {};
    cart.items.forEach(function (item, i) { keys[item.key] = item; lineByKey[item.key] = i + 1; });
    document.querySelectorAll('[data-cart-row]').forEach(function (row) {
      var rowKey = row.getAttribute('data-key');
      var item = keys[rowKey];
      if (!item) { row.remove(); return; }
      row.setAttribute('data-line', lineByKey[rowKey]);
      var qtyInput = row.querySelector('input[name="updates[]"]');
      if (qtyInput) { qtyInput.value = item.quantity; qtyInput.dataset.prev = item.quantity; }
      if (ctx && ctx.key === rowKey && typeof ctx.requested === 'number' && item.quantity < ctx.requested) {
        showQtyNote(row, 'Only ' + item.quantity + ' available — this piece is limited stock.');
      }
      var totalCell = row.querySelector('[data-line-total]');
      if (totalCell) totalCell.textContent = money(item.final_line_price);
      row.classList.remove('is-updating');
    });
    var sub = document.getElementById('jtj-subtotal');
    var tot = document.getElementById('jtj-total');
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    if (tot) tot.textContent = money(cart.total_price);
    flashTotal();
    var discRow = document.getElementById('jtj-discount-row');
    if (discRow) {
      if (cart.total_discount > 0) {
        discRow.style.display = '';
        var d = discRow.querySelector('[data-discount]');
        if (d) d.textContent = '\u2212' + money(cart.total_discount);
      } else {
        discRow.style.display = 'none';
      }
    }
  }

  function postChange(params) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: params
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error('Cart update failed');
          err.status = r.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function rejectQtyChange(row, err) {
    if (!row) return;
    row.classList.remove('is-updating');
    var input = row.querySelector('input[name="updates[]"]');
    if (input && input.dataset.prev) input.value = input.dataset.prev;
    var msg = (err && err.data && (err.data.description || err.data.message)) || 'Unable to update quantity.';
    showQtyNote(row, msg);
  }

  function changeLine(key, quantity, row) {
    if (row) row.classList.add('is-updating');
    var ctx = { key: key, requested: quantity };
    var byKey = new URLSearchParams();
    byKey.append('id', key);
    byKey.append('quantity', quantity);
    postChange(byKey)
      .then(function (cart) { updateCartDom(cart, ctx); })
      .catch(function (err) {
        if (err && err.status === 422) { rejectQtyChange(row, err); return; }
        // Fallback: address the row by its line number
        var line = row ? row.getAttribute('data-line') : null;
        if (!line) { window.location.reload(); return; }
        var byLine = new URLSearchParams();
        byLine.append('line', line);
        byLine.append('quantity', quantity);
        postChange(byLine).then(function (cart) {
          updateCartDom(cart, ctx);
        }).catch(function (err2) {
          if (err2 && err2.status === 422) { rejectQtyChange(row, err2); return; }
          window.location.reload();
        });
      });
  }

  var changeTimer = null;
  function scheduleChange(key, quantity, row) {
    clearTimeout(changeTimer);
    changeTimer = setTimeout(function () { changeLine(key, quantity, row); }, 300);
  }

  // Typed quantity changes in the cart
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('input[name="updates[]"]')) return;
    var row = input.closest('[data-cart-row]');
    if (!row) return;
    scheduleChange(row.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0), row);
  });

  // Remove links
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-remove]');
    if (!link) return;
    e.preventDefault();
    var row = link.closest('[data-cart-row]');
    changeLine(row.getAttribute('data-key'), 0, row);
  });

  /* ---------- Quantity steppers (PDP + cart) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jtj-qty button[data-qty]');
    if (!btn) return;
    var input = btn.closest('.jtj-qty').querySelector('input');
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty'), 10));
    var row = input.closest('[data-cart-row]');
    if (row) scheduleChange(row.getAttribute('data-key'), parseInt(input.value, 10), row);
  });

  /* ---------- Load More (collections) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;
    btn.disabled = true;
    btn.textContent = 'Loading\u2026';
    fetch(nextUrl)
      .then(function (r) { if (!r.ok) throw new Error('Load failed'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-collection-grid]');
        var grid = document.querySelector('[data-collection-grid]');
        if (newGrid && grid) {
          var added = [];
          Array.prototype.slice.call(newGrid.children).forEach(function (child) {
            grid.appendChild(child);
            added.push(child);
          });
          initReveal(added);
        }
        var newBtn = doc.querySelector('[data-load-more]');
        if (newBtn && newBtn.getAttribute('data-next-url')) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.disabled = false;
          btn.textContent = 'Load More';
        } else {
          btn.remove();
        }
      })
      .catch(function () { window.location.href = nextUrl; });
  });

  /* ---------- The Extra Mile benefits panel ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-benefits-open]');
    var closeEl = e.target.closest('[data-benefits-close]');
    if (!openBtn && !closeEl) return;
    var wrap = (openBtn || closeEl).closest('[data-benefits]');
    if (!wrap) return;
    var open = !!openBtn;
    wrap.classList.toggle('is-open', open);
    var tab = wrap.querySelector('[data-benefits-open]');
    if (tab) tab.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var closeBtn = wrap.querySelector('.jtj-benefits__close');
      if (closeBtn) closeBtn.focus();
    } else if (tab) {
      tab.focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wrap = document.querySelector('[data-benefits].is-open');
    if (!wrap) return;
    wrap.classList.remove('is-open');
    var tab = wrap.querySelector('[data-benefits-open]');
    if (tab) { tab.setAttribute('aria-expanded', 'false'); tab.focus(); }
  });
  // Close the panel when a link inside it is followed (e.g. the booking anchor)
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.jtj-benefits__panel a');
    if (!link) return;
    var wrap = link.closest('[data-benefits]');
    if (wrap) {
      wrap.classList.remove('is-open');
      var tab = wrap.querySelector('[data-benefits-open]');
      if (tab) tab.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- Scroll-reveal ---------- */
  var io = null;
  var revealIndex = 0;
  function ensureObserver() {
    if (io || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return io;
  }
  function initReveal(elements) {
    var obs = ensureObserver();
    if (!obs) return;
    elements.forEach(function (el) {
      if (el.classList.contains('jtj-reveal')) return;
      el.classList.add('jtj-reveal');
      el.style.transitionDelay = ((revealIndex % 4) * 70) + 'ms';
      revealIndex++;
      obs.observe(el);
    });
  }
  function scanReveal() {
    initReveal(Array.prototype.slice.call(document.querySelectorAll(
      '.jtj-card,.jtj-coll-card,.jtj-member,.jtj-post-card,.jtj-stat,.jtj-tile,' +
      '.jtj-split__media,.jtj-split__grid>div:not(.jtj-split__media),' +
      '.jtj-brand>.jtj-wrap,.jtj-cta__inner,.jtj-regrets__card,.jtj-team__head'
    )));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanReveal);
  } else {
    scanReveal();
  }
  // Re-scan when the Shopify theme editor re-renders a section
  document.addEventListener('shopify:section:load', scanReveal);

  /* ---------- Scroll cover/reveal: apply + auto-pair ---------- */
  function positionPinned() {
    // Sections taller than the viewport pin by their BOTTOM edge:
    // they scroll normally until fully read, then freeze for the cover.
    document.querySelectorAll('main .shopify-section.jtj-pinned').forEach(function (sec) {
      var offset = Math.min(0, window.innerHeight - sec.offsetHeight);
      sec.style.top = offset + 'px';
    });
  }

  var pinnedRO = ('ResizeObserver' in window) ? new ResizeObserver(positionPinned) : null;

  /* A pinned section may only be visible while its covering partner (the next
     section) still overlaps the viewport. Once the partner has fully scrolled
     past the top, the pinned section is hidden outright — so even if stacking
     ever goes wrong, a stuck section can never overlay the rest of the page.
     Scrolling back up, the partner re-enters and the pinned section reappears
     before the reveal begins, so the effect is seamless in both directions. */
  function capPinnedVisibility() {
    document.querySelectorAll('main .shopify-section.jtj-pinned').forEach(function (sec) {
      var next = sec.nextElementSibling;
      while (next && !next.classList.contains('shopify-section')) next = next.nextElementSibling;
      if (!next) { sec.style.visibility = ''; return; }
      var coverBottom = next.getBoundingClientRect().bottom;
      sec.style.visibility = coverBottom <= 0 ? 'hidden' : '';
    });
  }
  var capTick = false;
  function onScrollCap() {
    if (capTick) return;
    capTick = true;
    requestAnimationFrame(function () { capTick = false; capPinnedVisibility(); });
  }
  window.addEventListener('scroll', onScrollCap, { passive: true });

  function applyScrollEffects() {
    var sections = document.querySelectorAll('main .shopify-section');
    sections.forEach(function (sec) {
      sec.classList.remove('jtj-pinned', 'jtj-over');
      sec.style.top = '';
      sec.style.zIndex = '';
      sec.style.visibility = '';
      if (pinnedRO) pinnedRO.unobserve(sec);
    });
    sections.forEach(function (sec) {
      var eff = getComputedStyle(sec).getPropertyValue('--jtj-scroll-effect').trim();
      if (eff === 'pin') sec.classList.add('jtj-pinned');
      if (eff === 'over') {
        sec.classList.add('jtj-over');
        // Auto-pin the previous section so "slides over" always has something to cover
        var prev = sec.previousElementSibling;
        if (prev && prev.classList.contains('shopify-section')) {
          var prevEff = getComputedStyle(prev).getPropertyValue('--jtj-scroll-effect').trim();
          if (prevEff !== 'over') prev.classList.add('jtj-pinned');
        }
      }
    });
    // Deterministic stacking: a later section must ALWAYS paint above an
    // earlier one (that's what makes cover/reveal symmetric when scrolling
    // back up). Pinned sections live in a low band so everything after them
    // covers them while they're stuck; all other sections get an ascending
    // z-index in DOM order. Never rely on tie-breaking between equal z values.
    var i = 0;
    sections.forEach(function (sec) {
      i++;
      // Pinned band 1..n sits under the normal band 40+; both stay below
      // page chrome (header 90, Extra Mile tab 88, panels 118+).
      sec.style.zIndex = sec.classList.contains('jtj-pinned') ? i : (40 + i);
    });
    positionPinned();
    capPinnedVisibility();
    if (pinnedRO) {
      document.querySelectorAll('main .shopify-section.jtj-pinned').forEach(function (sec) {
        pinnedRO.observe(sec);
      });
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      positionPinned();
      if (window.innerWidth > 960) {
        document.querySelectorAll('.jtj-nav ul[style], .jtj-nav .jtj-mega[style], .jtj-mega2__list[style]').forEach(function (el) {
          el.style.maxHeight = '';
        });
      }
    }, 150);
  });
  // Re-apply fully once every resource has loaded (final section heights),
  // and again when the page is restored from the back/forward cache.
  window.addEventListener('load', applyScrollEffects);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) applyScrollEffects();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyScrollEffects);
  } else {
    applyScrollEffects();
  }
  document.addEventListener('shopify:section:load', applyScrollEffects);
  document.addEventListener('shopify:section:reorder', applyScrollEffects);

})();
